export interface CarCardData {
    id: string;
    carModel: string;
    year: number;
    fuelType: string;
    engineVolume: string;
    filterPrice: number; // Цена фильтра VIC
    oilType: string;
    oilLiters: number;
    oilBrands: string[]; 
    oilPrices: Record<string, number>; 
    airFilterPrice: number;
    cabinFilterPrice: number;
    initialAirFilter?: boolean;
    initialCabinFilter?: boolean;
    image: string;
    imagePosition?: {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
        transform?: string;
    };
}

export const testCarCardsData: CarCardData[] = [
    {
        id: "1",
        carModel: "Toyota RAV4",
        year: 2020,
        fuelType: "бензин",
        engineVolume: "2.5",
        filterPrice: 560,
        oilType: "0w20",
        oilLiters: 4.0,
        oilBrands: ["Toyota (оригинал)", "Tom'S"],
        oilPrices: {
            "Toyota (оригинал)": 6090,
            "Tom'S": 6510
        },
        airFilterPrice: 2550,
        cabinFilterPrice: 800,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/rav4-2020.png",
        imagePosition: { top: "12%" }
    },
    {
        id: "2",
        carModel: "LEXUS RX 350",
        year: 2020,
        fuelType: "бензин",
        engineVolume: "2.0",
        filterPrice: 840,
        oilType: "0w20",
        oilLiters: 6.1,
        oilBrands: ["Toyota (оригинал)", "Tom'S"],
        oilPrices: {
            "Toyota (оригинал)": 7830,
            "Tom'S": 8370
        },
        airFilterPrice: 2100,
        cabinFilterPrice: 1550,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/lexus-rx-350.png",
        imagePosition: { top: "13%", left: "2%", transform: "scale(0.85)" }
    },
    {
        id: "3",
        carModel: "Toyota HARRIER",
        year: 2021,
        fuelType: "бензин",
        engineVolume: "2.5",
        filterPrice: 510,
        oilType: "0w20",
        oilLiters: 4.3,
        oilBrands: ["Toyota (оригинал)", "Tom'S"],
        oilPrices: {
            "Toyota (оригинал)": 6090,
            "Tom'S": 6510
        },
        airFilterPrice: 1650,
        cabinFilterPrice: 1650,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/harrier-2021.png",
        imagePosition: { top: "12%", transform: "scale(0.94)"}
    },
    {
        id: "4",
        carModel: "Toyota CAMRY",
        year: 2020,
        fuelType: "бензин",
        engineVolume: "2.5",
        filterPrice: 830,
        oilType: "0w20",
        oilLiters: 4.0,
        oilBrands: ["Toyota (оригинал)", "Tom'S"],
        oilPrices: {
            "Toyota (оригинал)": 6380,
            "Tom'S": 6820
        },
        airFilterPrice: 2150,
        cabinFilterPrice: 1650,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/camry-2020.png",
        imagePosition: { top: "10%", transform: "scale(0.85)" }
    },
    {
        id: "5",
        carModel: "LAND CRUISER PRADO 150",
        year: 2018,
        fuelType: "бензин",
        engineVolume: "4.0",
        filterPrice: 780,
        oilType: "0w20",
        oilLiters: 6.2,
        oilBrands: ["Toyota (оригинал)", "Tom'S"],
        oilPrices: {
            "Toyota (оригинал)": 8845,
            "Tom'S": 9455
        },
        airFilterPrice: 1850,
        cabinFilterPrice: 1650,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/TO-card-prado150.png"
    },
    {
        id: "6",
        carModel: "Nissan X-TRAIL",
        year: 2015,
        fuelType: "бензин",
        engineVolume: "2.0",
        filterPrice: 550,
        oilType: "0w20 / 5w30",
        oilLiters: 4.0,
        oilBrands: ["Nissan (оригинал 0w20)", "Nissan (оригинал 5w30)"],
        oilPrices: {
            "Nissan (оригинал 0w20)": 5510,
            "Nissan (оригинал 5w30)": 4750
        },
        airFilterPrice: 2050,
        cabinFilterPrice: 1650,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/x-trail-2015.png",
        imagePosition: { top: "13%", transform: "scale(0.95)" }
    },
    {
        id: "7",
        carModel: "Nissan Juke",
        year: 2016,
        fuelType: "бензин",
        engineVolume: "1.5",
        filterPrice: 1100,
        oilType: "0w20 / 5w30",
        oilLiters: 3.7,
        oilBrands: ["Nissan (оригинал 0w20)", "Nissan (оригинал 5w30)"],
        oilPrices: {
            "Nissan (оригинал 0w20)": 4350,
            "Nissan (оригинал 5w30)": 3750
        },
        airFilterPrice: 1800,
        cabinFilterPrice: 1550,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/juke-2016.png",
        imagePosition: { top: "10%", transform: "scale(0.84)" }
    },
    {
        id: "8",
        carModel: "LAND CRUISER 200",
        year: 2020,
        fuelType: "дизель",
        engineVolume: "4.5",
        filterPrice: 1650,
        oilType: "0w30",
        oilLiters: 8.3,
        oilBrands: ["Toyota DL1 (оригинал)", "Tom'S"],
        oilPrices: {
            "Toyota DL1 (оригинал)": 11310,
            "Tom'S": 12090
        },
        airFilterPrice: 2800,
        cabinFilterPrice: 1540,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/TO-card-lc200.png"
    },
    {
        id: "9",
        carModel: "SUBARU FORESTER",
        year: 2016,
        fuelType: "бензин",
        engineVolume: "2.0",
        filterPrice: 540,
        oilType: "0w20",
        oilLiters: 4.8,
        oilBrands: ["Subaru (оригинал)"],
        oilPrices: {
            "Subaru (оригинал)": 8190
        },
        airFilterPrice: 1750,
        cabinFilterPrice: 2400,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/forester-2016.png",
        imagePosition: { top: "12%", transform: "scale(0.85)" }
    },
    {
        id: "10",
        carModel: "LEXUS GX 460",
        year: 2022,
        fuelType: "бензин",
        engineVolume: "4.6",
        filterPrice: 810,
        oilType: "0w20",
        oilLiters: 8.3,
        oilBrands: ["Toyota (оригинал)", "Tom'S"],
        oilPrices: {
            "Toyota (оригинал)": 11310,
            "Tom'S": 12090
        },
        airFilterPrice: 2300,
        cabinFilterPrice: 1650,
        initialAirFilter: false,
        initialCabinFilter: false,
        image: "/images/cars-store/lexus-gx.png",
        imagePosition: { top: "8%", left: "5%", transform: "scale(1.1)" }
    },
];